import { Controller } from "stimulus"
import $ from "../src/jquery-3.6.0.min"

export default class extends Controller {
  static targets = ["paramUrl", "tokenUrl", "documentId", "documentsUrl", "downloadButton", "signButton", "viewButton"]

  connect() {
    this.paramUrl = this.paramUrlTarget.value
    this.tokenUrl = this.tokenUrlTarget.value
    this.documentId = this.documentIdTarget.value
    this.documentsUrl = this.documentsUrlTarget.value

    console.log("🔗 paramUrl:", this.paramUrl)
    console.log("🔐 tokenUrl:", this.tokenUrl)
    console.log("🆔 documentId:", this.documentId)
    console.log("🚀 documentsUrl", this.documentsUrl)


    window.jQuery = $
    window.jqFirmaPeru = $.noConflict(true)
    window.signatureInit = () => {
      console.log("🟡 PROCESO INICIADO")
      this.signButtonTarget.disabled = true
      this.signButtonTarget.innerText = "Firmando..."
    }

    window.signatureOk = () => {
      console.log("🟢 DOCUMENTO FIRMADO")
      this.handleSignatureSuccess()
    }

    window.signatureCancel = () => {
      console.log("🔴 OPERACIÓN CANCELADA")
      this.signButtonTarget.disabled = false
      this.signButtonTarget.innerText = "Firmar documento"
    }
  }

  async waitUntilFileAvailable(url, maxRetries = 10, delayMs = 1000) {
    for (let i = 0; i < maxRetries; i++) {
      try {
        const resp = await fetch(url, {
          method: 'GET',
          headers: { Range: 'bytes=0-1' }
        });
        if (resp.ok || resp.status === 206) return true;
      } catch (err) {
        console.warn("Reintento fallo:", err)
      }
      await new Promise(resolve => setTimeout(resolve, delayMs));
    }
    return false;
  }

  async handleSignatureSuccess() {
    try {
      const patchResponse = await fetch(this.documentsUrl, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ status: "signed" })
      })

      if (patchResponse.ok) {
        const json = await patchResponse.json()
        console.log("📄 Documento actualizado:", json)

        const filename = encodeURIComponent(json.document.filename || "documento_firmado.pdf")
        const baseUrl = this.downloadButtonTarget.dataset.url
        const newUrl = `${baseUrl}?filename=${filename}`
        this.downloadButtonTarget.href = newUrl
        this.downloadButtonTarget.setAttribute("download", filename)
        this.downloadButtonTarget.classList.remove("hidden")
        this.viewButtonTarget.href = baseUrl
        this.viewButtonTarget.classList.remove("hidden")
        this.signButtonTarget.classList.add("hidden")
        const finalizeBtnWrapper = document.getElementById("finalize-button-wrapper")
        if (finalizeBtnWrapper) finalizeBtnWrapper.classList.remove("hidden")
        const signedWrapper = document.getElementById("signed-wrapper")
        if (signedWrapper) signedWrapper.classList.remove("hidden")
      } else {
        const errText = await patchResponse.text()
        console.error("❌ Error al actualizar documento:", errText)
      }
    } catch (e) {
      console.error("🚨 Error en handleSignatureSuccess:", e)
    }
  }

  async start() {
    const paramToken = await this.getToken(this.tokenUrl)
    const param = {
      param_url: `${this.paramUrl}?id=${this.documentId}`,
      param_token: paramToken,
      document_extension: "pdf"
    }
    console.log("🚀 ~ extends ~ start ~ param:", param)
    startSignature("48596", btoa(JSON.stringify(param)))
  }

  async getToken(url) {
    const response = await fetch(url)
    if (!response.ok) throw new Error("Error al obtener token")
    return await response.text()
  }

  async downloadSigned() {
    this.downloadButtonTarget.disabled = true
    this.downloadButtonTarget.innerText = "Descargando..."
    const url = this.downloadButtonTarget.dataset.url
    if (!url) {
      console.error("⚠️ No hay URL de descarga")
      return
    }

    const isReady = await this.waitUntilFileAvailable(url)
    if (!isReady) {
      alert("El archivo aún no está disponible. Intenta en unos segundos.")
      return
    }

    const response = await fetch(url)
    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)

    const tempLink = document.createElement("a")
    tempLink.href = blobUrl
    tempLink.download = this.extractFilenameFromUrl(url)
    document.body.appendChild(tempLink)
    tempLink.click()
    tempLink.remove()
    URL.revokeObjectURL(blobUrl)
    this.downloadButtonTarget.disabled = false
    this.downloadButtonTarget.innerText = "Descargar archivo firmado"
  }

  extractFilenameFromUrl(url) {
    const params = new URL(url).searchParams
    return params.get("filename") || "documento_firmado.pdf"
  }

  showModal(event) {
    event.preventDefault()
    const modal = document.getElementById("signedModal")
    const iframe = document.getElementById("wSignedIframe")
    iframe.src = this.viewButtonTarget.href
    modal.classList.remove("hidden")
  }

  closeModal() {
    const modal = document.getElementById("signedModal")
    const iframe = document.getElementById("wSignedIframe")
    iframe.src = "" // limpiar
    modal.classList.add("hidden")
  }

  async deleteSigned() {
    if (!confirm("¿Estás seguro de eliminar el documento firmado?")) return

    const fileUrl = this.downloadButtonTarget.dataset.url

    try {
      const deleteResp = await fetch(fileUrl, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (deleteResp.ok) {
        console.log("🗑️ Archivo firmado eliminado correctamente");
        const patchResp = await fetch(this.documentsUrl, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({ status: "uploaded" })
        });

        if (patchResp.ok) {
          console.log("📄 Documento actualizado a 'uploaded'");
          this.signButtonTarget.classList.remove("hidden")
          this.downloadButtonTarget.classList.add("hidden")
          this.viewButtonTarget.classList.add("hidden")
          const signedWrapper = document.getElementById("signed-wrapper")
          if (signedWrapper) signedWrapper.classList.add("hidden")
          const finalizeBtnWrapper = document.getElementById("finalize-button-wrapper")
          if (finalizeBtnWrapper) finalizeBtnWrapper.classList.add("hidden")
          alert("✅ Documento firmado eliminado. Ahora puedes volver a firmar.")
        } else {
          const err = await patchResp.text();
          console.error("❌ Error al actualizar documento:", err)
          alert("No se pudo actualizar el estado del documento.")
        }
      } else {
        const err = await deleteResp.text();
        console.error("❌ Error al eliminar el archivo firmado:", err)
        alert("No se pudo eliminar el archivo firmado.")
      }
    } catch (e) {
      console.error("🚨 Error inesperado en deleteSigned:", e)
      alert("Ocurrió un error inesperado al eliminar el documento.")
    }
  }
}
